import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useProductList = () => {
  const list = useSelector((state) => state.productSearch.productList);
  const loaded = useSelector((state) => state.productSearch.loaded);
  const loading = useSelector((state) => state.productSearch.loading);
  const [productList, setProductList] = useState([]);
  useEffect(() => {
    setProductList(list);
  }, [list]);

  return { productList, loaded, loading };
};

export default useProductList;
